
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_55fkh_jz55y_146",
  "textarea-readonly": "awsui_textarea-readonly_55fkh_jz55y_185",
  "disabled": "awsui_disabled_55fkh_jz55y_190",
  "textarea-invalid": "awsui_textarea-invalid_55fkh_jz55y_198",
  "textarea-warning": "awsui_textarea-warning_55fkh_jz55y_223",
  "textarea": "awsui_textarea_55fkh_jz55y_185",
  "invalid": "awsui_invalid_55fkh_jz55y_323",
  "warning": "awsui_warning_55fkh_jz55y_323",
  "textarea-wrapper": "awsui_textarea-wrapper_55fkh_jz55y_342",
  "button": "awsui_button_55fkh_jz55y_346",
  "action-button": "awsui_action-button_55fkh_jz55y_351",
  "secondary-content": "awsui_secondary-content_55fkh_jz55y_376",
  "with-paddings": "awsui_with-paddings_55fkh_jz55y_411",
  "secondary-actions": "awsui_secondary-actions_55fkh_jz55y_421",
  "buffer": "awsui_buffer_55fkh_jz55y_474"
};
  